var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"basket-quantity"},[(_vm.loaded)?[_c('basket-item-quantity',{model:{value:(_vm.count),callback:function ($$v) {_vm.count=$$v},expression:"count"}})]:[_c('loading-spinner')],_vm._v("\n\n  "+_vm._s(_vm.noun)+"\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }